<template>
  <div class="STInputBox">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      content-class="inputIn"
      max-width="290px"
      min-width="290px"
      offset-y
      transition="scale-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <input
          v-model="time"
          :class="isValid ? '' : 'notValid'"
          placeholder="ex)14:00"
          type="text"
          v-bind="attrs"
          @input="updateValue"
          v-on="on"
        />
      </template>

      <v-time-picker
        v-if="menu"
        v-model="time"
        format="24hr"
        full-width
        @input="updateValue"
        @click:minute="
          $refs.menu.save(time);
          menu = false;
        "
      ></v-time-picker>
    </v-menu>
    <span class="icon">
      <v-icon>mdi-clock-outline</v-icon>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    max: String,
    value: String,
  },
  data() {
    return {
      time: "",
      menu: false,
      isValid: true,
    };
  },
  watch: {
    value(e) {
      this.time = e;
    },
  },
  methods: {
    validatate() {
      return false;
    },
    updateValue(e) {
      let val = e;
      if (typeof e != "string") {
        val = e.target.value;
      }

      let result = this.$funcs.formatTime(val, false);
      val = result.val;
      this.isValid = result.isValid;

      this.time = val;

      //this.menu = false;
      this.$emit("input", val);
    },
  },
  created() {
    this.time = this.value;
  },
};
</script>

<style scoped>
.notValid {
  color: #f6654d !important;
}
</style>
